import { OAuth2Client } from './oauth2client/oauth2client';
import { Auth } from './auth/apis';
export { Auth } from './auth/apis';
import * as authModels_1 from './auth/models';
export { authModels_1 as authModels };
export class CloudbaseOAuth {
    constructor(authOptions) {
        const { apiOrigin, clientId, env, storage, request, baseRequest, anonymousSignInFunc, wxCloud } = authOptions;
        this.oauth2client = new OAuth2Client({
            apiOrigin,
            clientId,
            env,
            storage,
            baseRequest: baseRequest || request,
            anonymousSignInFunc,
            wxCloud,
        });
        this.authApi = new Auth({
            credentialsClient: this.oauth2client,
            ...authOptions,
            request: request ? this.oauth2client.request.bind(this.oauth2client) : undefined,
        });
    }
}
